export const translations = {
    de: {
        nav: {
            services: "Dienstleistungen",
            pricing: "Preise",
            offer: "Angebot",
            booking: "Anfragen",
            contact: "Kontakt",
            login: "Login",
        },
        hero: {
            tagline: "Schweizer Reinigungsservice",
            title: "Hand in Hand",
            title_accent: "mit Herzen",
            subtitle: "Sauberkeit, auf die Sie sich verlassen können. Für Privat, Büro und Gebäude — professionell, gründlich und umweltfreundlich.",
            cta_book: "Offerte anfragen",
            cta_offer: "Aktion ansehen",
            trust1: "Streifenfrei",
            trust2: "Gründlich",
            trust3: "Professionell",
            trust4: "Zuverlässig",
        },
        services: {
            overline: "Unsere Dienstleistungen",
            title: "Für jede Anforderung die passende Lösung",
            subtitle: "Wir bieten umfassende Reinigungslösungen für Privathaushalte, Büros und Gebäude in der ganzen Schweiz.",
            privat: { title: "Wohnungsreinigung", desc: "Küche, Bad, Boden, Fenster & Rahmen — die komplette Unterhaltsreinigung." },
            buero: { title: "Büro", desc: "Fensterreinigung, Büros & Praxen, Glastrennwände — und mehr." },
            gebaeude: { title: "Gebäude", desc: "Fassaden, Glasfronten, Treppenhäuser — und mehr." },
            scheiben: { title: "Scheiben & Schaufenster", desc: "Streifenfreie Sicht und ein perfekter Eindruck." },
            begleit: { title: "Begleitservice", desc: "Einkaufshilfe, Begleitung zu Terminen, Alltagshilfe — mit Herz." },
        },
        offer: {
            badge: "Neukunden-Rabatt",
            title: "Scheiben & Schaufenster Reinigung",
            subtitle: "Für klare Sicht und einen perfekten Eindruck. Jetzt profitieren und sparen!",
            from: "Statt",
            to: "Nur",
            cta: "Aktion sichern",
        },
        booking: {
            overline: "Online anfragen",
            title: "In 60 Sekunden zur Offerte",
            subtitle: "Füllen Sie das Formular aus und wir melden uns innerhalb von 24 Stunden mit einer Richtofferte.",
            name: "Ihr Name",
            email: "E-Mail (optional)",
            phone: "Telefon",
            address: "Adresse",
            city: "Ort",
            postal: "PLZ",
            service: "Dienstleistung",
            date: "Wunschdatum",
            time: "Wunschzeit (optional)",
            message: "Nachricht (optional)",
            submit: "Offerte anfragen",
            success: "Vielen Dank! Wir melden uns in Kürze mit einer Offerte.",
            select_service: "Bitte wählen",
        },
        values: {
            v1_title: "Zufriedene Kunden",
            v1_desc: "Ihre Zufriedenheit liegt uns am Herzen.",
            v2_title: "Umweltfreundlich",
            v2_desc: "Wir verwenden umweltfreundliche Reinigungsmittel.",
            v3_title: "Überzeugende Sauberkeit",
            v3_desc: "Für Privat, Büro und Gebäude — immer professionell.",
        },
        footer: {
            slogan: "Hand in Hand mit Herzen",
            tagline: "Sauberkeit, auf die Sie sich verlassen können.",
            contact: "Kontakt",
            services_h: "Dienstleistungen",
            rights: "Alle Rechte vorbehalten.",
        },
    },
    fr: {
        nav: { services: "Services", pricing: "Prix", offer: "Offre", booking: "Réserver", contact: "Contact", login: "Connexion" },
        hero: {
            tagline: "Service de nettoyage suisse",
            title: "Main dans la main",
            title_accent: "avec le cœur",
            subtitle: "Une propreté sur laquelle vous pouvez compter. Pour les particuliers, bureaux et bâtiments — professionnel et écologique.",
            cta_book: "Demander une offre",
            cta_offer: "Voir l'offre",
            trust1: "Sans traces",
            trust2: "Minutieux",
            trust3: "Professionnel",
            trust4: "Fiable",
        },
        services: {
            overline: "Nos services",
            title: "Une solution pour chaque besoin",
            subtitle: "Solutions complètes de nettoyage pour particuliers, bureaux et bâtiments dans toute la Suisse.",
            privat: { title: "Ménage privé", desc: "Cuisine, salle de bains, sols, fenêtres — entretien complet." },
            buero: { title: "Bureau", desc: "Vitres, bureaux & cabinets, cloisons vitrées." },
            gebaeude: { title: "Bâtiment", desc: "Façades, vitrines, cages d'escalier." },
            scheiben: { title: "Vitres & Vitrines", desc: "Une vue claire et une impression parfaite." },
            begleit: { title: "Accompagnement", desc: "Aide aux courses, accompagnement, aide quotidienne." },
        },
        offer: {
            badge: "Remise nouveaux clients",
            title: "Nettoyage des vitres & vitrines",
            subtitle: "Pour une vue claire et une impression parfaite. Profitez maintenant !",
            from: "Au lieu de",
            to: "Seulement",
            cta: "Profiter de l'offre",
        },
        booking: {
            overline: "Demande en ligne",
            title: "Une offre en 60 secondes",
            subtitle: "Remplissez le formulaire, nous vous envoyons une offre indicative sous 24 heures.",
            name: "Votre nom",
            email: "E-mail (optionnel)",
            phone: "Téléphone",
            address: "Adresse",
            city: "Ville",
            postal: "NPA",
            service: "Service",
            date: "Date souhaitée",
            time: "Heure souhaitée (optionnel)",
            message: "Message (optionnel)",
            submit: "Demander une offre",
            success: "Merci ! Nous revenons vers vous rapidement avec une offre.",
            select_service: "Veuillez choisir",
        },
        values: {
            v1_title: "Clients satisfaits",
            v1_desc: "Votre satisfaction nous tient à cœur.",
            v2_title: "Écologique",
            v2_desc: "Nous utilisons des produits respectueux.",
            v3_title: "Propreté convaincante",
            v3_desc: "Toujours professionnel.",
        },
        footer: {
            slogan: "Main dans la main avec le cœur",
            tagline: "Une propreté fiable.",
            contact: "Contact",
            services_h: "Services",
            rights: "Tous droits réservés.",
        },
    },
    it: {
        nav: { services: "Servizi", pricing: "Prezzi", offer: "Offerta", booking: "Prenota", contact: "Contatto", login: "Accesso" },
        hero: {
            tagline: "Servizio di pulizie svizzero",
            title: "Mano nella mano",
            title_accent: "con il cuore",
            subtitle: "Pulizia su cui puoi contare. Per case, uffici e edifici — professionale ed ecologico.",
            cta_book: "Richiedi un'offerta",
            cta_offer: "Vedi offerta",
            trust1: "Senza aloni",
            trust2: "Accurato",
            trust3: "Professionale",
            trust4: "Affidabile",
        },
        services: {
            overline: "I nostri servizi",
            title: "Una soluzione per ogni esigenza",
            subtitle: "Soluzioni complete di pulizia in tutta la Svizzera.",
            privat: { title: "Pulizia casa", desc: "Cucina, bagno, pavimenti, finestre — manutenzione completa." },
            buero: { title: "Ufficio", desc: "Vetri, uffici e studi, pareti divisorie." },
            gebaeude: { title: "Edificio", desc: "Facciate, vetrate, scale." },
            scheiben: { title: "Vetri & Vetrine", desc: "Vista chiara e impressione perfetta." },
            begleit: { title: "Accompagnamento", desc: "Aiuto spesa, accompagnamento, aiuto quotidiano." },
        },
        offer: {
            badge: "Sconto nuovi clienti",
            title: "Pulizia vetri & vetrine",
            subtitle: "Per una vista chiara. Approfittane ora!",
            from: "Invece di",
            to: "Solo",
            cta: "Ottieni l'offerta",
        },
        booking: {
            overline: "Richiesta online",
            title: "Un'offerta in 60 secondi",
            subtitle: "Compila il modulo, ti inviamo un'offerta indicativa entro 24 ore.",
            name: "Il tuo nome",
            email: "E-mail (facoltativo)",
            phone: "Telefono",
            address: "Indirizzo",
            city: "Città",
            postal: "CAP",
            service: "Servizio",
            date: "Data desiderata",
            time: "Orario (facoltativo)",
            message: "Messaggio (facoltativo)",
            submit: "Richiedi un'offerta",
            success: "Grazie! Ti contattiamo presto con un'offerta.",
            select_service: "Seleziona",
        },
        values: {
            v1_title: "Clienti soddisfatti",
            v1_desc: "La tua soddisfazione ci sta a cuore.",
            v2_title: "Ecologico",
            v2_desc: "Usiamo prodotti rispettosi.",
            v3_title: "Pulizia convincente",
            v3_desc: "Sempre professionale.",
        },
        footer: {
            slogan: "Mano nella mano con il cuore",
            tagline: "Pulizia su cui contare.",
            contact: "Contatto",
            services_h: "Servizi",
            rights: "Tutti i diritti riservati.",
        },
    },
    en: {
        nav: { services: "Services", pricing: "Pricing", offer: "Offer", booking: "Book", contact: "Contact", login: "Login" },
        hero: {
            tagline: "Swiss cleaning service",
            title: "Hand in hand",
            title_accent: "with heart",
            subtitle: "Cleanliness you can rely on. For homes, offices and buildings — professional, thorough and eco-friendly.",
            cta_book: "Request a quote",
            cta_offer: "See offer",
            trust1: "Streak-free",
            trust2: "Thorough",
            trust3: "Professional",
            trust4: "Reliable",
        },
        services: {
            overline: "Our services",
            title: "A perfect solution for every need",
            subtitle: "Comprehensive cleaning solutions across Switzerland.",
            privat: { title: "Home Cleaning", desc: "Kitchen, bath, floors, windows — full maintenance cleaning." },
            buero: { title: "Office", desc: "Window cleaning, offices & practices, glass partitions." },
            gebaeude: { title: "Building", desc: "Facades, glass fronts, stairwells." },
            scheiben: { title: "Windows & Storefronts", desc: "Crystal clear view and a perfect first impression." },
            begleit: { title: "Companion service", desc: "Shopping help, accompaniment, daily assistance." },
        },
        offer: {
            badge: "New customer discount",
            title: "Window & Storefront Cleaning",
            subtitle: "For a clear view and a perfect impression. Save now!",
            from: "Instead of",
            to: "Only",
            cta: "Claim offer",
        },
        booking: {
            overline: "Request online",
            title: "Get a quote in 60 seconds",
            subtitle: "Fill in the form and we'll get back to you within 24 hours with a quote.",
            name: "Your name",
            email: "Email (optional)",
            phone: "Phone",
            address: "Address",
            city: "City",
            postal: "Postal code",
            service: "Service",
            date: "Preferred date",
            time: "Preferred time (optional)",
            message: "Message (optional)",
            submit: "Request quote",
            success: "Thank you! We'll get back to you with a quote shortly.",
            select_service: "Please choose",
        },
        values: {
            v1_title: "Happy customers",
            v1_desc: "Your satisfaction is our heart.",
            v2_title: "Eco-friendly",
            v2_desc: "We use environmentally friendly products.",
            v3_title: "Convincing cleanliness",
            v3_desc: "Always professional.",
        },
        footer: {
            slogan: "Hand in hand with heart",
            tagline: "Cleanliness you can rely on.",
            contact: "Contact",
            services_h: "Services",
            rights: "All rights reserved.",
        },
    },
};

export const LANGUAGES = [
    { code: "de", label: "DE" },
    { code: "fr", label: "FR" },
    { code: "it", label: "IT" },
    { code: "en", label: "EN" },
];
